<template>
  <div>
    <!-- 搜索区域 -->
    <el-form :inline="true" :model="form" class="demo-form-inline">
      <el-form-item label="题目ID">
        <el-input
          v-model="form.code"
          placeholder="请输入"
          clearable
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="题目">
        <el-input
          v-model="form.title"
          placeholder="请输入"
          clearable
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="题型">
        <el-select v-model="form.type" placeholder="请选择" clearable>
          <el-option
            v-for="(item, index) in OQuestionType"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联课程">
        <el-select
          v-model="form.courseId"
          placeholder="请选择关联课程"
          clearable
          filterable
          style="width: 200px"
        >
          <el-option
            v-for="item in courseListOptions"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <div class="flex align-items marginRight10 marginBottom10">
          <el-button size="medium" type="primary" @click="handleSearch"
            >搜索</el-button
          >
        </div>
      </el-form-item>
      <el-form-item>
        <div class="flex align-items marginRight10 marginBottom10">
          <el-button size="medium" type="info" @click="handleReset"
            >重置</el-button
          >
        </div>
      </el-form-item>
      <!-- <el-form-item>
        <div class="flex align-items marginRight10 marginBottom10">
          <el-button
            size="medium"
            style="background: #f59a23; color: #ffffff; border-color: #f59a23"
            @click="handleImport"
            >导入</el-button
          >
        </div>
      </el-form-item> -->

      <el-form-item v-if="isDisabled">
        <div class="flex align-items marginRight10 marginBottom10">
          <el-button size="medium" type="primary" @click="handleCreate"
            >新增题目</el-button
          >
        </div>
      </el-form-item>
    </el-form>
    <div class="select_box marginBottom20" v-if="!isDisabled">
      <el-button style="cursor: auto"
        >已选题目({{ checkedList.length }})</el-button
      >
      <el-button type="primary" @click="handleSave">保存并返回</el-button>
    </div>
    <!-- 内容区域 -->
    <div class="question-box">
      <div class="question-list" v-for="item in tableData" :key="item.id">
        <!-- 勾选功能 -->
        <div class="item_checkbox" v-if="!isDisabled">
          <el-checkbox
            v-model="item.isChecked"
            @change="handleChecked(item)"
          ></el-checkbox>
        </div>
        <div class="item_box">
          <div class="flex align-items">
            <div
              class="item_type"
              :class="
                item.type == EQuestionType.single
                  ? 'item_yellow'
                  : item.type == EQuestionType.multiple
                  ? 'item_green'
                  : 'item_blue'
              "
            >
              {{ MQuestionType[item.type] }}
            </div>
            <el-tag
              v-if="getCourseName(item.courseId)"
              size="small"
              type="info"
              style="margin-left: 10px"
            >
              课程：{{ getCourseName(item.courseId) }}
            </el-tag>
          </div>
          <div class="item_title">
            {{ `${item.indexOf}.` }}<span>{{ item.title }}</span>
          </div>
          <div class="item_options">
            <div
              class="item_option"
              v-for="(value, key) in item.titleOptionJson"
              :key="key"
            >
              <div class="item_option_title">{{ key }}.{{ value }}</div>
            </div>
          </div>
          <div class="answer_flex">
            <div class="item_answer">
              <div class="item_answer_title">【答案】：</div>
              <div class="item_answer_content" v-if="item.answer">
                {{ item.answer }}
              </div>
            </div>
            <div class="item_answer_btn" v-if="isDisabled">
              <el-button @click="handleEdit(item)">编辑</el-button>
              <el-button @click="handleDelete(item)">删除</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 暂无数据空状态提示 -->
      <el-empty
        v-if="!tableData || tableData.length === 0"
        description="暂无数据"
        :image-size="120"
      ></el-empty>
    </div>
    <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 300, 40, 50, 100]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      >
      </el-pagination>
    </div>
    <Import
      v-if="importShow"
      :show="importShow"
      :action="importAction"
      :downloadLink="importDownloadLink"
      :problemLink="importProblem"
      @close="importClose"
    />
  </div>
</template>

<script>
import {
  OQuestionType,
  MQuestionType,
  EQuestionType,
} from "@/enums/beCurrent/EBeCurrent";
import Import from "@/components/import";
import { courseInfoListAll } from "@/api/course/info";

export default {
  name: "index",
  components: {
    Import,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    page: {
      type: Object,
      default: () => {},
    },
    // 禁止操作
    isDisabled: {
      type: Boolean,
      default: false,
    },
    questionIds: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    questionIds: {
      handler(newVal) {
        console.log(newVal, "eee");

        this.checkedList = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      OQuestionType,
      MQuestionType,
      EQuestionType,
      form: {
        code: "",
        type: "",
        title: "",
        courseId: "",
      },
      checkedList: [],
      importShow: false, //导入弹窗
      importAction: "/api/web/question/manage/template/import",
      importProblem: "/web/question/manage/template/error/export",
      importDownloadLink: "/web/question/manage/template/export",
      courseListOptions: [], // 全量课程下拉列表
      courseMap: {}, // 课程 ID 与标题映射表
    };
  },
  created() {
    this.getCourseList();
  },
  methods: {
    /**
     * 获取全量课程列表数据，用于关联课程下拉检索及列表名称展示
     * 
     * @param {void} 无参数
     * @returns {Promise<void>} 无返回值
     */
    async getCourseList() {
      try {
        const res = await courseInfoListAll();
        if (res.code === 200 && Array.isArray(res.data)) {
          this.courseListOptions = res.data;
          const map = {};
          res.data.forEach((c) => {
            map[c.id] = c.title;
          });
          this.courseMap = map;
        }
      } catch (error) {
        console.error("获取全量课程列表失败:", error);
      }
    },

    /**
     * 根据课程ID获取课程标题
     * 
     * @param {string} courseId 课程ID
     * @returns {string} 课程标题名称
     */
    getCourseName(courseId) {
      if (!courseId) return "";
      return this.courseMap[courseId] || "";
    },

    handleSearch() {
      console.log(this.form, "this.formthis.form");

      this.$emit("handleSearch", this.form);
    },
    handleReset() {
      this.form = {
        code: "",
        type: "",
        title: "",
        courseId: "",
      };
      this.$emit("handleReset");
    },
    // 新增
    handleCreate() {
      this.$emit("handleCreate", "create");
    },
    // 选中
    handleChecked(item) {
      if (item.isChecked) {
        this.checkedList.push(item);
      } else {
        this.checkedList = this.checkedList.filter((i) => item.id !== i.id);
      }
    },
    // 编辑
    handleEdit(item) {
      this.$emit("handleEdit", item);
    },
    // 删除
    handleDelete(item) {
      this.$emit("handleDelete", item);
    },
    // 分页
    handleSizeChange(size) {
      this.$emit("handleSizeChange", size);
    },
    handleCurrentChange(page) {
      this.$emit("handleCurrentChange", page);
    },
    handleSave() {
      this.$emit("handleSave", this.checkedList);
    },
    // 批量导入
    handleImport() {
      this.importShow = true;
    },
    // 导入弹框关闭
    importClose(e) {
      this.importShow = false;
      console.log("e111", e);
      this.$emit("handleSearch", this.form);
    },
  },
};
</script>

<style scoped lang="scss">
.question-list {
  display: flex;
  background: #fff;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  border: 1px solid #ddd;

  .item_checkbox {
    margin-top: 32px;
  }
  .item_box {
    width: 100%;
    .item_title {
      margin-top: 8px;
      span {
        margin-left: 10px;
      }
    }
    .item_type {
      margin-left: 15px;
      display: inline-block;
      color: #fff;
      padding: 5px 10px;
      border-radius: 5px;
      text-align: center;
    }

    .item_option {
      margin-top: 10px;
      margin-left: 15px;
    }
    .item_option_title {
    }
    .item_yellow {
      background-color: #ffbf6b;
    }
    .item_green {
      background-color: #00be8c;
    }
    .item_blue {
      background-color: #409eff;
    }

    .answer_flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      .item_answer {
        margin-left: 15px;
        display: flex;
        align-items: center;
        font-weight: bold;
        .item_answer_content {
        }
      }
      .item_answer_btn {
        margin-left: 15px;
        margin-right: 5%;
        display: flex;
        align-items: center;
      }
    }
  }
}
.pagination-box {
  text-align: right;
  margin-top: 10px;
}
</style>
